import React from 'react';
import PredefinedList from '../components/predefined/PredefinedList';

const PredefinedMessages = () => {
  return (
    <div className="container py-4">
      <PredefinedList />
    </div>
  );
};

export default PredefinedMessages;
